"use strict";
function postponedFlightsValidator() {
    return function (control) {
        var value = control.value;
        // When no flights are being provided, the flightsLater value is requried to be true or false
        if (value.noFlights && !(value.flightsLater === true || value.flightsLater === false)) {
            return { 'flightsLaterRequired': true };
        }
        return null;
    };
}
exports.postponedFlightsValidator = postponedFlightsValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/postponed-flights.validator.js